import ContainerCustom from "../../../Components/ContainerCustom";
import LeverageValueList from "./LeverageValueList";
import { formatLeverage } from "../../../helper/formatLeverage";
import { displayNumber, displayPercent, displayValue, hasDisplayValue } from "../../../helper/displayValue";

function Row({ label, children, ltr = false }) {
  return <div className="flex justify-between items-center py-3 gap-10"><p className="text-zi-text-light dark:text-zi-text-dark">{label}</p><div dir={ltr ? "ltr" : "rtl"} className="text-zi-text-light dark:text-zi-text-dark font-medium [unicode-bidi:isolate]">{children}</div></div>;
}
function ratioPercent(value) {
  if (!hasDisplayValue(value)) return "-";
  const numeric = Number(value);
  return displayPercent(numeric <= 1 ? numeric * 100 : numeric);
}

export default function ChallengeInfoContainer({ data }) {
  const discountedCost = hasDisplayValue(data?.discount_cost) && Number(data.discount_cost) !== 0 ? data.discount_cost : data?.cost;
  return <ContainerCustom header="اطلاعات چالش" headSVG="info" search={false} filter={false} sort={false} colorfulFilter={false} divider={false} className="flex-none">
    <section className="flex justify-between gap-20 w-full overflow-x-auto text-nowrap">
      <article className="w-full flex flex-col divide-y divide-zi-border-light dark:divide-zi-border-dark/50">
        <Row label="نوع چالش">{data?.challenge_type ? (data.challenge_type === "real" ? "واقعی" : "تمرینی") : "-"}</Row>
        <Row label="قیمت چالش" ltr>{hasDisplayValue(data?.cost) ? `$${displayNumber(data.cost)}` : "-"}</Row>
        <Row label="سرمایه اولیه" ltr>{hasDisplayValue(data?.initial_balance) ? `$${displayNumber(data.initial_balance)}` : "-"}</Row>
        <Row label="نوع اهرم">{data?.leverage_mode === "selectable" ? "انتخاب توسط معامله‌گر" : data?.leverage_mode === "fixed" ? "ثابت" : "-"}</Row>
        <Row label="مقادیر اهرم" ltr>{data?.leverage_mode === "selectable" ? <LeverageValueList values={data?.allowed_leverages} /> : formatLeverage(data?.fixed_leverage ?? data?.leverage)}</Row>
        <Row label="حداقل روز معاملاتی برای برداشت" ltr>{displayValue(data?.first_payout_delay_days)}</Row>
        <Row label="روش محاسبه درادان کل">ثابت</Row>
      </article>
      <article className="w-full flex flex-col divide-y divide-zi-border-light dark:divide-zi-border-dark/50">
        <Row label="دسته چالش">{displayValue(data?.category)}</Row>
        <Row label="درصد تخفیف" ltr>{displayPercent(data?.discount_percent ?? 0)}</Row>
        <Row label="پلتفرم معامله">کوژیتو</Row>
        <Row label="درصد تقسیم سود" ltr>{ratioPercent(data?.profit_split_ratio)}</Row>
        <Row label="حداقل روز برای برداشت پس از اولین معامله" ltr>{displayValue(data?.first_payout_delay_days_after_trade)}</Row>
        <Row label="روش محاسبه درادان روزانه">روزانه</Row>
      </article>
      <article className="w-full flex flex-col divide-y divide-zi-border-light dark:divide-zi-border-dark/50">
        <Row label="نام چالش">{displayValue(data?.name)}</Row>
        <Row label="قیمت پس از تخفیف" ltr>{hasDisplayValue(discountedCost) ? `$${displayNumber(discountedCost)}` : "-"}</Row>
        <Row label="نوع بازار">{data?.market === "crypto" ? "ارز دیجیتال" : displayValue(data?.market)}</Row>
        <Row label="درصد بازگشت هزینه اولیه" ltr>{displayPercent(data?.refundable_fee)}</Row>
        <Row label="حداکثر روز غیرفعال بودن حساب">-</Row>
        <Row label="روش محاسبه درادان معامله">روزانه</Row>
      </article>
    </section>
  </ContainerCustom>;
}
